import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../css/ticker.css';

export default function Ticker() {
  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear"
  };

  return (
    <div className="mainContainer">
      <Slider {...settings}>
        <div className="img-kerjasama">
          <img src="../../assets/tentang/kerjasama1.svg" alt="slide" />
        </div>
        <div className="img-kerjasama">
          <img src="../../assets/tentang/kerjasama2.svg" alt="slide" />
        </div>
        <div className="img-kerjasama">
          <img src="../../assets/tentang/kerjasama3.svg" alt="slide" />
        </div>
        <div className="img-kerjasama">
          <img src="../../assets/tentang/kerjasama4.svg" alt="slide" />
        </div>
      </Slider>
    </div>
  );
}
